// ** Handles Layout Content Width (full / boxed)
export const settingsUpdateContentWidth = data => dispatch => dispatch({ type: 'SETTINGS_UPDATE_CONTENT_WIDTH', data })

// ** Handles Menu Collapsed State (Bool)
export const settingsToggleMenuCollapsed = data => dispatch => dispatch({ type: 'SETTINGS_TOGGLE_MENU_COLLAPSED', data })

// ** Handles Menu Hidden State (Bool)
export const settingsToggleMenuHidden = data => dispatch => dispatch({ type: 'SETTINGS_TOGGLE_MENU_HIDDEN', data })

// ** Handles RTL (Bool)
export const settingsToggleRTL = data => dispatch => dispatch({ type: 'SETTINGS_TOGGLE_RTL', data })
